import { Icon, Pagination as SMUIPagination } from 'semantic-ui-react';

type PaginationPropsType = {
    page: number;
    totalPages: number;
    setPage: (page: number) => void;
};
function Pagination({ page, setPage, totalPages }: PaginationPropsType) {
    return (
        <SMUIPagination
            defaultActivePage={page + 1}
            ellipsisItem={{ content: <Icon name="ellipsis horizontal" />, icon: true }}
            firstItem={{ content: <Icon name="angle double left" />, icon: true }}
            lastItem={{ content: <Icon name="angle double right" />, icon: true }}
            prevItem={{ content: <Icon name="angle left" />, icon: true }}
            nextItem={{ content: <Icon name="angle right" />, icon: true }}
            totalPages={totalPages}
            onPageChange={(_, data) => setPage(Number(data.activePage) - 1)}
        />
    );
}

export default Pagination;
